import React, { useState, useEffect} from 'react';
import apiCall, { TEST_URL, LIVE_URL } from '~/utils/apiCall';

export const useSearchModal = (selectMyAddress, closeModal) => {
  
  const [searchState, setSearchState] = useState({
    isLoading: false,
    input: '',
    inputResultList:[], 
  })

  function useDebounce(func, delay, trackValue) {
    let timer = {};
    
    useEffect(() => {
      if (trackValue) {
        timer = setTimeout(() => {
          func()
        }, delay);
        return () => {
          clearTimeout(timer);
        }
      }
    }, [trackValue]);
  }

  useDebounce(
    () => {
      onChangeSubmit(searchState.input);
    },
    1000,
    searchState.input
  );

  const onChangeInput = (e) => {
    const { value } = e.target; 
    let obj = {};
  
    if (value) {
      obj = {
        isLoading: true
      }
    } else {
      obj = {
        isLoading: false,
        inputResultList: []
      }
    }

    setSearchState(prev => ({...prev, input: value, ...obj }));
  }

  const onChangeSubmit = async inputValue  => {
    const host = process.env.NODE_ENV === 'development' ? TEST_URL : LIVE_URL

    try {
      const { result } = await apiCall.get(`${host}/api/v1/regions`, { keyword: inputValue });
      setSearchState({ inputResultList: result, isLoading: false });

    } catch (err) {
      console.log(err);
      setSearchState(prev => ({ ...prev, inputResultList: [], isLoading: false }));
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  };
  
  const clickAddress = (value) => {
    selectMyAddress(value);
    closeModal()
  }

  return {
    searchState,
    onChangeInput,
    clickAddress,
  }
};
